import * as _ from 'lodash-es';
import { AdminActivity } from '../model/adminActivity';
import { DaysBuilder } from './days-builder';
export class AdminActivityBuilder {
    static buildAdminActivity(data) {
        let activity = null;
        activity = new AdminActivity();
        activity.step_start = data.step_start;
        activity.step_end = data.step_end;
        activity.days = _.map(data.days, (days) => {
            return DaysBuilder.buildDays(days);
        });
        return activity;
    }
}
//# sourceMappingURL=adminActivity-builder.js.map